import { useMutation } from "@apollo/client";
import { SAVE_DYNAMIC_PROCESS_MODEL } from "../api/save-dynamic-process-model";
import { FieldsType } from "./types";
import { useModelId } from "./model-id/use-model-id";
import { GET_ALL_DYNAMIC_PROCESSES } from "@/modules/admin-panel/dynamic-processes/entities/dynamic-processes-list";

export function useSaveDynamicProcessModel() {
  const [saveDynamicProcessModel, { loading }] = useMutation(
    SAVE_DYNAMIC_PROCESS_MODEL,
  );

  const { setModelId } = useModelId();

  const save = async (process: FieldsType) => {
    const response = await saveDynamicProcessModel({
      variables: {
        process,
      },
      refetchQueries: [GET_ALL_DYNAMIC_PROCESSES],
    });

    const modelId = response.data?.saveDynamicProcessModel.id;

    if (modelId) {
      setModelId(modelId);
    }
  };

  return {
    save,
    loading,
  };
}
